import { render, staticRenderFns } from "./myBankBlueCard.vue?vue&type=template&id=764e1a22&scoped=true&"
import script from "./myBankBlueCard.vue?vue&type=script&lang=js&"
export * from "./myBankBlueCard.vue?vue&type=script&lang=js&"
import style0 from "./myBankBlueCard.vue?vue&type=style&index=0&id=764e1a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e1a22",
  null
  
)

export default component.exports